export default class Task {
    id: number;
    dataset: number;
    dataset_name: string;
    annotation_interface: number;
    annotation_interface_name: string;
    annotation_tool: number;
    media_cnt: number;
    type: "image" | "video";
    annotations: number;
    physicians_cnt: number;
    assignment_date: Date;
    dataset_description: string;
    annotation_interface_description: string;

    constructor(obj: Task) {
        this.id = obj.id;
        this.dataset = obj.dataset;
        this.dataset_name = obj.dataset_name;
        this.annotation_interface = obj.annotation_interface;
        this.annotation_interface_name = obj.annotation_interface_name;
        this.annotation_tool = obj.annotation_tool;
        this.media_cnt = parseInt(obj.media_cnt as any);
        this.type = obj.type;
        this.physicians_cnt = obj.physicians_cnt;
        this.annotations = obj.annotations;
        this.assignment_date = new Date(obj.assignment_date);
        this.dataset_description = obj.dataset_description;
        this.annotation_interface_description = obj.annotation_interface_description;
    }

    name = () => {
        return `${this.dataset_name} - ${this.annotation_interface_name}`;
    };

    filter = (search: string): boolean => {
        search = search.toLowerCase();
        return this.name().toLowerCase().includes(search);
    };

    overallProgress = () => {
        let percent;
        if (this.media_cnt > 0 && this.physicians_cnt > 0)
            percent = this.annotations / (this.media_cnt * this.physicians_cnt);
        else percent = 0.0;
        return Math.round(percent * 10000) / 100;
    };
}
